import { Link } from "react-router-dom";
import { Route } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ScenarioRowProps } from "./scenario-row-types";

export function ScenarioVariantInline({
  scenario,
  effectiveHref,
  onSelect,
  badge,
  className,
}: Pick<ScenarioRowProps, "scenario" | "onSelect" | "badge" | "className"> & {
  effectiveHref: string | null;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 font-medium text-foreground",
        className,
      )}
    >
      <Route
        className="size-3.5 shrink-0 text-muted-foreground"
        aria-hidden="true"
      />
      {effectiveHref ? (
        <Link
          to={effectiveHref}
          onClick={(e) => {
            if (
              onSelect &&
              !e.metaKey &&
              !e.ctrlKey &&
              !e.shiftKey &&
              !e.altKey &&
              e.button === 0
            ) {
              e.preventDefault();
              onSelect(scenario.id);
            }
          }}
          className="underline decoration-border underline-offset-4 hover:decoration-foreground"
          title={scenario.name}
        >
          {scenario.name}
        </Link>
      ) : onSelect ? (
        <button
          type="button"
          onClick={() => onSelect(scenario.id)}
          className="cursor-pointer text-left underline decoration-border underline-offset-4 hover:decoration-foreground"
          title={scenario.name}
        >
          {scenario.name}
        </button>
      ) : (
        <span>{scenario.name}</span>
      )}
      {badge}
    </span>
  );
}
